import React from 'react';
import styled from '@emotion/styled';
import { SPACING_6B } from '@styles/constants/spacings';
import { Fonts, mediaQuery } from '@styles/index';
import Typography from '@unicons-base/Typography/Typography';

interface SectionTitleProps {
  title: string;
  className?: string;
}

const StyledTitle = styled(Typography)`
  font-size: ${Fonts.H4};
  font-weight: ${Fonts.BOLD};
  color: var(--color-i-icon-light-tertiary);
  margin-bottom: ${SPACING_6B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.H4};
    font-weight: ${Fonts.SEMIBOLD};
    margin-bottom: ${SPACING_6B};
  }
`;

const SectionTitle: React.FC<SectionTitleProps> = ({ title, className }) => {
  return <StyledTitle className={className}>{title}</StyledTitle>;
};

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;
